import ApiConfig from "../config/Api.config";
import Data from "../data/Api.data";
import Queja from "../interfaces/Queja.interface";
import Request from "../interfaces/Request.interface";
import Response from "../interfaces/Response.interface";
import UsuarioModel from "../models/Usuario.model";

const urlSinergia: string = `${Data.URLS.urlApiSinergia}/queja`
const urlREDECO: string = `${Data.URLS.urlApiREDECO}`

const listar = async (mes: string) => {
    const request: Request = {
        url: `${urlSinergia}/listar/${mes}`,
        method: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const eliminar = async (Id: number) => {
    const request: Request = {
        url: `${urlSinergia}/eliminar/${Id}`,
        method: "DELETE",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};

const guardar = async (queja: Queja) => {
    const request: Request = {
        url: `${urlSinergia}/guardar`,
        method: "POST",
        data: { queja }
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};

const listarProductos = async () => {

    const token: string = UsuarioModel.getToken();

    const request: Request = {
        url: `${urlREDECO}/catalogos/products-list`,
        method: "GET",
        headers: {
            Authorization: token
        }
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const listarProductosCausa = async (productId: string) => {
    const token: string = UsuarioModel.getToken();
    const request: Request = {
        url: `${urlREDECO}/catalogos/causas-list/?product=${productId}`,
        method: "GET",
        headers: {
            Authorization: token
        }
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const QuejaService = {
    /** ApiSinergia */
    listar,
    eliminar,
    guardar,

    /** REDECO */
    listarProductos,
    listarProductosCausa,
};

export default QuejaService;